import styled from 'styled-components'

export const LogoRoot = styled.div`
  display: flex;
  align-items: center;
`

export const LogoIcon = styled.div`
  width: 103px;
  height: 20px;

  & img {
    width: 100%;
  }
`
